import "index.scss";
import "@NuFlights/nf-ui-components-ndc-connect-v2/styles.css";
// i18next is initialized as a module-level side effect in "i18n". It must be
// imported explicitly here, at the app's real entry point, rather than left
// to whatever component happens to transitively pull it in (previously only
// Header.tsx -> LanguageSwitcher did) — otherwise translations only load by
// accident, and any unrelated refactor that drops that import silently stops
// i18next from initializing at all, surfacing raw "k_xxxxxxxx" hash keys in
// the UI instead of translated text.
import "i18n";
import Store from "store";
import ReactDOM from "react-dom";
import Loader from "utils/Loader";
import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import { createStore, StoreProvider } from "easy-peasy";
import { store } from "api/client";

const clientStore = store;
const LazyApp = lazy(() => import("App"));

const AppRoot = (
  <React.StrictMode>
    <StoreProvider store={clientStore}>
      <Suspense fallback={<Loader />}>
        <LazyApp />
      </Suspense>
    </StoreProvider>
  </React.StrictMode>
);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(AppRoot);

// ReactDOM.render(AppRoot, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
